// hooks
import { useMetamask } from './contexts/Metamask';

// libraries
import { Switch, Route } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

// pages
import ConnectMetamask from './pages/ConnectMetamask';
import SwitchToDesktop from './pages/SwitchToDesktop';
import ClaimTokens from './pages/ClaimTokens';
import Admin from './pages/Admin';

import './App.scss';
import { APP_CONFIG } from 'config';

export default function App() {
  const wallet = useMetamask();

  if (APP_CONFIG.DISABLE_ON_MOBILE && isMobile) {
    return <SwitchToDesktop />;
  }

  if (!wallet?.account) {
    return <ConnectMetamask />;
  }

  return (
    <Switch>
      <Route exact path="/admin" component={Admin} />
      <Route exact path="/" component={ClaimTokens} />
    </Switch>
  );
}
